const route = (def, ref) => ({
  def: def,
  ref: ref || (() => def),
});

export default {
  /* Login */
  login: route('/login'),

  myLoggers: route('/'),

  createLogger: route('/createlogger'),

  loggerLanding: route('/:loggerId'),

  /* Dashboard */
  activity: route(
    '/:loggerId/activity',
    (loggerId) => `/${loggerId}/activity`
  ),
  performance: route(
    '/:loggerId/performance',
    (loggerId) => `/${loggerId}/performance`
  ),
  liveSessions: route(
    '/:loggerId/live',
    (loggerId) => `/${loggerId}/live`
  ),
  requesters: route(
    '/:loggerId/requesters',
    (loggerId) => `/${loggerId}/requesters`
  ),
  networks: route(
    '/:loggerId/networks',
    (loggerId) => `/${loggerId}/networks`
  ),

  /* General */
  logs: route(
    '/:loggerId/logs',
    (loggerId) => `/${loggerId}/logs`
  ),
  bots: route(
    '/:loggerId/bots',
    (loggerId) => `/${loggerId}/bots`
  ),
  blacklist: route(
    '/:loggerId/blacklist',
    (loggerId) => `/${loggerId}/blacklist`
  ),
  whitelist: route(
    '/:loggerId/whitelist',
    (loggerId) => `/${loggerId}/whitelist`
  ),
  notifications: route(
    '/:loggerId/notification',
    (loggerId) => `/${loggerId}/notification`
  ),

  /* Options */
  rules: route(
    '/:loggerId/rules',
    (loggerId) => `/${loggerId}/rules`
  ),
  keys: route(
    '/:loggerId/keys',
    (loggerId) => `/${loggerId}/keys`
  ),
  settings: route(
    '/:loggerId/settings',
    (loggerId) => `/${loggerId}/settings`
  ),
  crawlers: route(
    '/:loggerId/crawlers',
    (loggerId) => `/${loggerId}/crawlers`
  ),
  stopwords: route(
    '/:loggerId/stopwords',
    (loggerId) => `/${loggerId}/stopwords`
  ),
  groups: route(
    '/:loggerId/groups',
    (loggerId) => `/${loggerId}/groups`
  ),

  /* Requester specific */
  requestersRequests: route(
    '/:loggerId/requesters/:requesterId',
    (loggerId, requesterId) => `/${loggerId}/requesters/${requesterId}`
  ),
};
